import { ReactNode } from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

type PanelSectionProps = {
  title: string;
  children: ReactNode;
};

export const PanelSection = ({ title, children }: PanelSectionProps) => (
  <Paper variant="outlined" sx={{ position: 'relative', p: 2 }}>
    <Box position="absolute" top={-12} left={10} bgcolor="background.paper" px={1}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
    </Box>
    <Stack spacing={1.5} pt={0.5}>
      {children}
    </Stack>
  </Paper>
);
